import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { CATEGORY_IDS } from "../lib/constants";
import { useT } from "../i18n/I18nContext";

export default function PostRequest() {
  const navigate = useNavigate();
  const t = useT();
  const [form, setForm] = useState({
    title: "", category: "home", description: "", location: "", date: "", estimated_duration: "",
  });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/requests", form);
      navigate(`/app/richieste/${data.id}`);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-10 md:py-14 anim-fade-up" data-testid="post-request-page">
      <div className="text-xs uppercase tracking-[0.22em] text-mabw-secondary font-semibold mb-2">{t("post.overline")}</div>
      <h1 className="text-3xl md:text-4xl font-semibold" style={{ fontFamily: "Outfit" }}>{t("post.title")}</h1>
      <p className="text-mabw-soft mt-2 max-w-xl">{t("post.sub")}</p>

      <form onSubmit={onSubmit} className="mt-8 card-mabw p-6 md:p-8 space-y-5">
        <div>
          <label className="text-sm font-medium" htmlFor="rq-title">{t("post.title_label")}</label>
          <input id="rq-title" required maxLength={120} value={form.title} onChange={set("title")}
            className="input-mabw mt-1.5" placeholder={t("post.title_placeholder")}
            data-testid="rq-title-input" />
        </div>

        <div>
          <label className="text-sm font-medium" htmlFor="rq-cat">{t("post.category")}</label>
          <select id="rq-cat" value={form.category} onChange={set("category")}
            className="input-mabw mt-1.5" data-testid="rq-category-select">
            {CATEGORY_IDS.map((id) => <option key={id} value={id}>{t(`categories.${id}.label`)}</option>)}
          </select>
        </div>

        <div>
          <label className="text-sm font-medium" htmlFor="rq-desc">{t("post.description")}</label>
          <textarea id="rq-desc" required rows={5} value={form.description} onChange={set("description")}
            className="input-mabw mt-1.5 resize-none"
            placeholder={t("post.description_placeholder")}
            data-testid="rq-description-input" />
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className="text-sm font-medium" htmlFor="rq-loc">{t("post.location")}</label>
            <input id="rq-loc" required value={form.location} onChange={set("location")}
              className="input-mabw mt-1.5" placeholder={t("post.location_placeholder")}
              data-testid="rq-location-input" />
          </div>
          <div>
            <label className="text-sm font-medium" htmlFor="rq-date">{t("post.date")}</label>
            <input id="rq-date" required type="date" value={form.date} onChange={set("date")}
              className="input-mabw mt-1.5" data-testid="rq-date-input" />
          </div>
        </div>

        <div>
          <label className="text-sm font-medium" htmlFor="rq-dur">{t("post.duration")}</label>
          <input id="rq-dur" required value={form.estimated_duration} onChange={set("estimated_duration")}
            className="input-mabw mt-1.5" placeholder={t("post.duration_placeholder")}
            data-testid="rq-duration-input" />
        </div>

        {error && (
          <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-3 py-2" data-testid="rq-error">
            {error}
          </div>
        )}

        <div className="flex flex-wrap gap-3 pt-2">
          <button type="submit" disabled={busy} className="btn-mabw" data-testid="rq-submit-btn">
            {busy ? t("post.publishing") : t("post.submit")}
          </button>
          <button type="button" onClick={() => navigate(-1)} className="btn-mabw-secondary" data-testid="rq-cancel-btn">
            {t("post.cancel")}
          </button>
        </div>
      </form>
    </div>
  );
}
